import React, { useEffect, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import Swal from "sweetalert2";
import { studyEventManagementServices } from "../../../../../APIServices/studyEventManagementServices";
import { studyEventFormSchemaServices } from "../../../../../APIServices/studyEventFormSchemaServices";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const EventListForAssignForm = ({ tableRef, onMouseDown, metadata }) => {
  const [eventColumns, setEventColumns] = useState([]);
  const [eventRows, setEventRows] = useState([]);
  const [version, setVersion] = useState("");
  const [schemaId, setSchemaId] = useState("");
  const [eventSchema, setEventSchema] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedEventIds, setSelectedEventIds] = useState([]);
  let { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false)

  const getStudyEventColumnData = async (e) => {
    let data = await studyEventManagementServices.getStudyEventColumnData(
      "active",
      studyId
    );
    setEventColumns(data?.data || []);
  };

  const getEventBasedonSchema = async (e) => {
    setLoading(true);
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(
      studyId,
      schemaId
    );
    setEventRows(data?.data || []);
    setLoading(false);
  };

  const getEventFormSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setEventSchema(data?.data || []);
    setSchemaId(data?.data[0]?.schemaId || []);
  };

  const findAssignedEventForm = async (e) => {
    setDataLoading(true);
    let data = await studyEventManagementServices.findAssignedEventForm(
      studyId,
      metadata?.formId,
      schemaId,
      version
    );
    setSelectedEventIds(
      (data?.data || [])?.map((item) => ({
        eventId: item.eventId,
        version: item.formVersion,
        timePointUniqueId: item.timePointUniqueId || "",
      }))
    );
    setDataLoading(false);
  };

  useEffect(() => {
    if (studyId && schemaId && version) {
      findAssignedEventForm();
    }
  }, [studyId, schemaId, version]);

  const addUpdateStudyEventSchema = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${
        !schemaId ? "Add new" : "Update"
      } Study Event Schema!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${!schemaId ? "create" : "update"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.studyId = studyId;
        userData.schemaId = schemaId;
        userData.version = String(version);
        userData.eventIds = selectedEventIds;
        userData.formId = metadata?.formId;
        userData.formName = metadata?.formName;
        let data = await studyEventManagementServices.addUpdateStudyEventSchema(
          userData
        );
        if (data?.statusCode === 200) {
          getEventFormSchema();
          setSchemaId("");
        }
        setButtonLoader(false)
      }
    });
  };

  let checkFormVersion =
    selectedEventIds?.length > 0
      ? selectedEventIds?.some(
          (item) => Number(item.version) === Number(version)
        )
      : true;

  useEffect(() => {
    setVersion("");
    setSchemaId("");
    setSelectedEventIds([]);
  }, [metadata]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = eventRows.map((item) => ({
        eventId: item.eventId,
        version: version,
        timePointUniqueId: String(item.row?.["TIMEPOINTUNIQUEID"] || ""),
      }));
      setSelectedEventIds(allIds);
    } else {
      setSelectedEventIds([]);
    }
  };

  const handleSingleSelect = (eventId, timePointUniqueId) => {
    setSelectedEventIds((prevSelected) => {
      const exists = prevSelected.some(
        (item) =>
          item.eventId === eventId &&
          item.timePointUniqueId === timePointUniqueId
      );

      if (exists) {
        return prevSelected.filter(
          (item) =>
            !(
              item.eventId === eventId &&
              item.timePointUniqueId === timePointUniqueId
            )
        );
      } else {
        return [
          ...prevSelected,
          { eventId, version, timePointUniqueId: timePointUniqueId || "" },
        ];
      }
    });
  };

  const isAllSelected =
    eventRows?.length > 0 &&
    selectedEventIds?.length === eventRows?.length &&
    eventRows.every((row) =>
      selectedEventIds.some(
        (selected) =>
          selected.eventId === row.eventId &&
          Number(selected.version) === Number(version) &&
          selected.timePointUniqueId ===
            String(row.row?.["TIMEPOINTUNIQUEID"] || "")
      )
    );

  useEffect(() => {
    getStudyEventColumnData();
    getEventFormSchema();
  }, []);

  useEffect(() => {
    if (schemaId) {
      getEventBasedonSchema();
    }
  }, [schemaId]);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"15%"}
        style={{ height: "-webkit-fill-available" }}
      >
        <Table ref={tableRef} className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>Form Version</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: metadata?.version || 1 }, (_, i) => i + 1)
              ?.reverse()
              ?.map((versionNumber, index) => (
                <tr
                  onClick={() => setVersion(versionNumber)}
                  key={index}
                  className={`CP ${
                    version === versionNumber ? "highlighted" : ""
                  }`}
                >
                  <td>Version {versionNumber}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {version && (
          <>
            <div className="hstack justify-content-between p-2 position-sticky top-0 z-1">
              <Form.Select
                onChange={(e) => setSchemaId(e.target.value)}
                style={{ fontSize: 12, width: 200 }}
                className="br3"
                disabled={eventSchema?.length === 0}
              >
                {eventSchema?.length > 0 ? (
                  eventSchema?.map((item, index) => (
                    <option
                      selected={schemaId === item?.schemaId}
                      key={index}
                      value={item?.schemaId}
                    >
                      {item?.schemaName}
                    </option>
                  ))
                ) : (
                  <option value={""}>No Schema</option>
                )}
              </Form.Select>
              <div>
                <button
                  disabled={!version || buttonLoader}
                  onClick={addUpdateStudyEventSchema}
                  className="updateProfile"
                >
                  {buttonLoader ? (
                    <div className="hstack gap-2">
                      <Spinner size="sm"/> Assiging...
                    </div>
                  ) : (
                    "Assign Now"
                  )}
                </button>
              </div>
            </div>
            <SplitPane
              split="vertical"
              minSize={"100%"}
              style={{ height: "-webkit-fill-available" }}
            >
              {loading && dataLoading ? (
                <PageLoader/>
              ) : eventRows?.length === 0 ? (
                <NoDataFoundTable MSG={"Please select form verdion..."} />
              ) : (
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        <Form.Check
                          type="checkbox"
                          disabled={!version || !checkFormVersion}
                          onChange={handleSelectAll}
                          checked={isAllSelected}
                        />
                      </th>
                      {eventColumns?.map((column, index) => (
                        <th onMouseDown={(e) => onMouseDown(e, index + 1)}>
                          {column?.columnLabel}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {eventRows?.map((row, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <Form.Check
                            type="checkbox"
                            disabled={!version || !checkFormVersion}
                            checked={selectedEventIds.some(
                              (selected) =>
                                selected.eventId === row.eventId &&
                                Number(selected.version) === Number(version) &&
                                selected.timePointUniqueId ===
                                  String(row.row?.["TIMEPOINTUNIQUEID"] || "")
                            )}
                            onChange={() =>
                              handleSingleSelect(
                                row.eventId,
                                String(row.row?.["TIMEPOINTUNIQUEID"] || "")
                              )
                            }
                          />
                        </td>
                        {eventColumns?.map((column, i) => (
                          <td key={i}>{row?.row[column?.columnName] || ""}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </SplitPane>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default EventListForAssignForm;
